export default __webpack_public_path__ + "static/media/functions_openapi.a5176f06.yaml";